import React, { FC, memo, useState } from 'react';
import ErrorMessage from '../errorMessage';
import { CardExpiryElement } from '@stripe/react-stripe-js';
import { StripeCardExpiryElementChangeEvent, StripeCardExpiryElementOptions } from '@stripe/stripe-js';
import { getCardFieldOptions } from '../../constants';
import classnames from 'classnames';
import s from './index.module.scss';
import locales from '../../../../../../../../../../content.json';

type Props = {
  className?: string;
  onChange?: (event: StripeCardExpiryElementChangeEvent) => void;
  options?: StripeCardExpiryElementOptions;
};

const CardExpire: FC<Props> = props => {
  const { className, onChange, options = getCardFieldOptions() } = props;
  const [empty, setEmpty] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>();
  const [isFieldEmpty, setIsFieldEmpty] = useState<boolean>(true); // << добавляем второй стейт

  const handleChange = (event: StripeCardExpiryElementChangeEvent) => {
    setError(event.error?.message);
    setIsFieldEmpty(event.empty); // << сохраняем пусто/не пусто
    onChange && onChange(event);
  };

  const handleFocus = () => {
    setEmpty(true);
  };

  const handleBlur = () => {
    setEmpty(!isFieldEmpty);
  };

  return (
    <>
      <div className={classnames(className, s.cardExpiry, { [s.empty]: empty })}>
        <CardExpiryElement 
          onChange={handleChange} 
          onFocus={handleFocus} 
          onBlur={handleBlur} 
          options={options} 
        />
        {empty && (
          <span className={s.cardExpiry_title}>{locales[window.userLang].payment_text_106}</span>
        )}
      </div>
      {/* {error && <ErrorMessage error={error} />} */}
      <ErrorMessage error={error} />
    </>
  );
};

export default memo(CardExpire);
